// extracted by mini-css-extract-plugin
module.exports = {"label":"_f5afc38f","value":"_a5f52622"};